import { render } from "./SeniorityCeiling.vue?vue&type=template&id=f71ebe90"
import script from "./SeniorityCeiling.vue?vue&type=script&lang=js"
export * from "./SeniorityCeiling.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__